/* Built In Imports */
import React, { useEffect, useState } from 'react';

/* External Imports */
import {
    Box, Button,
    Link, ListItem, Text,
    UnorderedList
} from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
/* Services */
import { fetchPackageData } from 'services/exclusiveService';

/* Styles */

/**
 * Renders the SubscriptionPlan component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} SubscriptionPlan component
 */

const SubscriptionPlan = ({
  sectionContent,
  region,
  language,
  sectionId,
  eventtype,
}) => {
  const [PackageData, setPackageData] = useState([]);
  let setSectionId = '';
  if (sectionId != undefined) {
    setSectionId = sectionId;
  } else {
    setSectionId = 'Subscription';
  }
  const subscripData = sectionContent.body.find(
    el => el.sectionId == setSectionId
  );
  // const preurl = ShortCodeProcess(
  //   subscripData?.sectionContent[7]?.linkUrl != ''
  //     ? subscripData?.sectionContent[7]?.linkUrl?.toString()
  //     : ''
  // );
  const posturl = refineUrlDomain(
    subscripData?.sectionContent[7]?.linkUrl,
    region,
    language
  );
  useEffect(() => {
    localData();
  }, [region]);
  const localData = async () => {
    const res = await fetchPackageData(region, language);
    const PackageData = res.data;
    // consoleLog('package', PackageData);
    setPackageData(PackageData);
  };

  /**
   *
   */
  function onsubmit() {
    document.querySelector('#package_name').value = document.querySelector(
      'input[name="planfee"]:checked'
    ).value;
    document.querySelector('#iso2').value = region.toUpperCase();
    subscribe.submit();
  }
  /**
   *
   * @param packagename
   * @param ios2
   */
  function formsubmit(packagename, ios2) {
    document.querySelector('#package_name').value = packagename;
    document.querySelector('#iso2').value = ios2;
    subscribe.submit();
  }

  return (
    <>
      <a name="subscriptionplan" />
      <form
        id="subscribeplan"
        method="post"
        name="subscribe"
        action={posturl}
        enctype="application/json"
      >
        <input type="hidden" name="package" id="package_name" />
        <input type="hidden" name="country" id="iso2" />
        {/* <input type="hidden" name="offer" id="offer_code" /> */}
        {PackageData[0]?.currency == 'INR' && region == 'in' ? (
          <>
            <Text
              as="h2"
              fontSize={{ base: '24px', lg: '30px' }}
              marginTop="100px"
              fontFamily="FedraSansStd-A-medium"
              padding="20px 0"
              color="#ffffff"
            >
              {subscripData?.sectionContent[0]?.titleText}
              <br />
              {subscripData?.sectionContent[0]?.titleSubtext}
            </Text>
            <Box
              background="#2f2c29"
              marginTop="30px"
              borderRadius="12px"
              padding={{ base: '50px 25px', lg: '50px' }}
              width={{ base: '100%', sm: '92%', lg: '1024px' }}
              margin="30px auto 0"
              color="#ffffff"
            >
              {subscripData?.sectionContent[1].text != '' && (
                <>
                  <UnorderedList
                    display="inline-block"
                    textAlign="left"
                    fontSize={{ base: '16px', lg: '20px' }}
                    fontFamily="FedraSansStd-book"
                  >
                    <ListItem marginBottom="25px">
                      {subscripData?.sectionContent[1]?.text}
                    </ListItem>
                    <ListItem marginBottom="25px">
                      {subscripData?.sectionContent[2]?.text}
                    </ListItem>
                    <ListItem marginBottom="25px">
                      {subscripData?.sectionContent[3]?.text}
                    </ListItem>
                  </UnorderedList>
                </>
              )}

              <Box display="flex" mt="30px" padding="0 calc((100% - 810px)/2)">
                <Box
                  border="solid 2px #ffbd31"
                  borderRadius="14px"
                  padding="0"
                  minHeight="185px"
                  margin={{ base: '0 12px 0 0', sm: '0 40px 0 0' }}
                  w={{
                    base: 'calc((100% - 6px)/2)',
                    sm: 'calc((100% - 40px)/2)',
                  }}
                  position="relative"
                  cursor="pointer"
                >
                  <label for="plan_1" display="block" cursor="pointer">
                    <Text
                      color="#ffbd31"
                      background="#2f2c29"
                      padding="5px"
                      fontFamily="FedraSansStd-medium"
                      fontSize={{ base: '10px', sm: '12px' }}
                      position="absolute"
                      top={{ base: '-13px', sm: '-15px' }}
                      left="0"
                      right="0"
                      margin="0 auto"
                      w="max-content"
                      cursor="pointer"
                    >
                      {subscripData?.sectionContent[4]?.text}
                    </Text>
                    <Box
                      position="absolute"
                      top="20px"
                      left="0"
                      background="#ffbd31"
                      padding="5px 20px 5px 5px"
                      fontFamily="FedraSansStd-medium"
                      color="#121212"
                      fontSize={{ base: '10px', sm: '16px' }}
                      cursor="pointer"
                    >
                      {PackageData[0]?.package_discount_percentage}
                      {subscripData?.sectionContent[9]?.text}
                      <Text
                        as="span"
                        cotent=" '' "
                        position="absolute"
                        top={{ base: '-6px', sm: '0' }}
                        right={{ base: '-13px', sm: '-13px' }}
                        w={{ base: '19px', sm: '25px' }}
                        h="30px"
                        background="#2f2c29"
                        transform="rotate(45deg)"
                        cursor="pointer"
                      ></Text>
                    </Box>
                    <Text
                      fontSize={{ base: '20px', sm: '24px' }}
                      color="#ffffff"
                      marginTop={{ base: '43px', sm: '13px' }}
                      cursor="pointer"
                    >
                      {subscripData?.sectionContent[5]?.text}
                    </Text>
                    <Text
                      fontSize={{ base: '20px', sm: '30px' }}
                      color="#ffffff"
                      fontFamily="FedraSansStd-medium"
                      lineHeight="22px"
                      cursor="pointer"
                    >
                      <strike cursor="pointer">
                        {PackageData[0]?.currency == 'INR' ? (
                          <>{subscripData?.sectionContent[10]?.text}</>
                        ) : (
                          <>{PackageData[0]?.currency}</>
                        )}{' '}
                        {PackageData[0]?.package_projected_price}
                      </strike>
                    </Text>
                    <Box display="flex" cursor="pointer">
                      <Box
                        w={{ base: '24px', sm: '42px' }}
                        h={{ base: '24px', sm: '42px' }}
                        background="#121212"
                        borderRadius="50%"
                        m={{
                          base: '10px 0px 0 18px',
                          lg: '20px 20px 0 62px',
                        }}
                        backgroundSize="100%"
                        className="selectplan"
                      >
                        <input
                          type="radio"
                          name="planfee"
                          id="plan_1"
                          value={PackageData[0]?.package_name}
                          // onChange={plancheck.bind('plan_1')}
                          checked
                          cursor="pointer"
                        />
                      </Box>
                      <Box
                        fontSize={{ base: '32px', sm: '48px' }}
                        color="#ffbd31"
                        fontFamily="FedraSansStd-medium"
                        lineHeight={{ base: '35px', sm: '49px' }}
                        m={{ base: '0 0 0 5px', lg: '0 0 0 29px' }}
                      >
                        <Text as="span" fontSize={{ base: '15px', sm: '32px' }}>
                          {PackageData[0]?.currency == 'INR' ? (
                            <>{subscripData?.sectionContent[10]?.text}</>
                          ) : (
                            <>{PackageData[0]?.currency}</>
                          )}
                        </Text>{' '}
                        {PackageData[0]?.package_amount}
                      </Box>
                    </Box>
                    <Text
                      fontSize={{ base: '14px', lg: '' }}
                      background={{ base: '#ffbd31', lg: 'unset' }}
                      color={{ base: '#121212', lg: 'unset' }}
                      borderRadius={{ base: '5', lg: 'unset' }}
                      position={{ base: 'absolute', lg: 'unset' }}
                      w={{ base: '100%', lg: 'unset' }}
                      bottom={{ base: '-34px', lg: 'unset' }}
                      fontFamily={{
                        base: 'FedraSansStd-medium',
                        lg: 'unset',
                      }}
                    >
                      {subscripData?.sectionContent[11]?.text}{' '}
                      {PackageData[0]?.currency == 'INR' ? (
                        <>{subscripData?.sectionContent[10]?.text}</>
                      ) : (
                        <>{PackageData[0]?.currency}</>
                      )}{' '}
                      {PackageData[0]?.package_discount_price}
                    </Text>
                  </label>
                </Box>

                <Box
                  border="solid 2px #ffbd31"
                  borderRadius="14px"
                  padding="0"
                  minHeight="185px"
                  margin="0"
                  w={{
                    base: 'calc((100% - 6px)/2)',
                    sm: 'calc((100% - 40px)/2)',
                  }}
                  position="relative"
                  cursor="pointer"
                >
                  <label
                    for="plan_2"
                    cursor="pointer"
                    display="block"
                    width="100%"
                    height="100%"
                  >
                    <Text
                      fontSize={{ base: '20px', sm: '24px' }}
                      color="#ffffff"
                      marginTop={{ base: '43px', sm: '13px' }}
                      cursor="pointer"
                    >
                      {subscripData?.sectionContent[6]?.text}
                    </Text>
                    <Box
                      display="flex"
                      m={{ base: '20px 0 0 0', sm: '0', lg: '22px 0 0 0' }}
                      cursor="pointer"
                    >
                      <Box
                        w={{ base: '24px', sm: '42px' }}
                        h={{ base: '24px', sm: '42px' }}
                        background="#121212"
                        borderRadius="50%"
                        m={{
                          base: '10px 4px 0 25px',
                          lg: '10px 20px 0 62px',
                        }}
                        className="selectplan"
                        cursor="pointer"
                      >
                        <input
                          type="radio"
                          name="planfee"
                          id="plan_2"
                          value={PackageData[1]?.package_name}
                          cursor="pointer"
                          // onChange={plancheck.bind('plan_2')}
                        />
                      </Box>
                      <Box
                        color="#ffbd31"
                        fontFamily="FedraSansStd-medium"
                        fontSize={{ base: '32px', sm: '48px' }}
                        lineHeight={{ base: '35px', sm: '49px' }}
                        m={{ base: '0 0 0 2px', lg: '0 0 0 29px' }}
                        cursor="pointer"
                      >
                        <Text
                          as="span"
                          fontSize={{ base: '15px', sm: '32px' }}
                          cursor="pointer"
                        >
                          {PackageData[0]?.currency == 'INR' ? (
                            <>{subscripData?.sectionContent[10]?.text}</>
                          ) : (
                            <>{PackageData[0]?.currency}</>
                          )}
                        </Text>{' '}
                        {PackageData[1]?.package_amount}
                      </Box>
                    </Box>
                  </label>
                </Box>
              </Box>
              {subscripData?.sectionContent[7]?.buttonText != '' &&
                subscripData?.sectionContent[7]?.linkUrl != '' && (
                  <>
                    <Box>
                      <Button
                        background="#ffbd31"
                        _hover={{ background: '#ffbd31' }}
                        _active={{ background: '#ffbd31' }}
                        _focus={{ boxShadow: 'none' }}
                        onClick={onsubmit.bind()}
                        w={{ base: '80%', sm: '40%', lg: '300px' }}
                        m="64px auto 0 !important"
                        height="50px"
                        fontWeight="normal"
                        cursor="pointer"
                      >
                        <Link
                          w={{ base: '100%', sm: '40%', lg: '300px' }}
                          fontFamily="FedraSansStd-A-medium"
                          fontSize={{ base: '20px', lg: '22px' }}
                          lineHeight="48px"
                          textAlign="center"
                          display="block"
                          background="#ffbd31"
                          color="#2c2a29"
                          borderRadius="7px"
                          _hover={{ textDecor: 'none' }}
                          cursor="pointer"
                        >
                          {subscripData?.sectionContent[7]?.buttonText}
                        </Link>
                      </Button>
                    </Box>
                  </>
                )}
            </Box>
            <Box m="5px 0 0 0">
              <Text
                fontSize="16px"
                fontFamily="FedraSansStd-book"
                // borderBottom="1px solid #ffbd31"
                color="#ffbd31"
                className="privacylink"
              >
                {StructuredTextContent(subscripData?.sectionContent[8]?.body)}
              </Text>
            </Box>
          </>
        ) : (
          <>
            <Text
              fontSize={{ base: '24px', lg: '30px' }}
              marginTop="100px"
              fontFamily="FedraSansStd-A-medium"
              padding="20px 0"
              color="#ffffff"
            >
              {subscripData?.sectionContent[0]?.titleText}
              <br />
              {subscripData?.sectionContent[0]?.titleSubtext}
            </Text>
            <Box
              display={{ base: 'block', md: 'flex' }}
              padding="0 calc((100% - 1020px)/2)"
            >
              <Box
                background="#2f2c29"
                borderRadius="12px"
                padding={{
                  base: '30px 25px 20px 25px',
                  lg: '30px 25px 20px 25px',
                }}
                width={{ base: '100%', sm: '96%', lg: '50%' }}
                margin="30px auto 0"
                color="#ffffff"
              >
                <Box
                  fontSize="28px"
                  fontFamily="FedraSansStd-A-medium, sans-serif"
                >
                  {subscripData?.sectionContent[5]?.text}{' '}
                </Box>
                <Text
                  color="#ffbd31"
                  background="#2f2c29"
                  padding="5px"
                  fontFamily="FedraSansStd-medium"
                  fontSize={{ base: '10px', sm: '12px' }}
                  margin="0 auto"
                  w="max-content"
                >
                  {subscripData?.sectionContent[4]?.text}
                </Text>
                <Box
                  fontSize={{ base: '32px', sm: '48px' }}
                  color="#ffbd31"
                  fontFamily="FedraSansStd-book, sans-serif"
                  lineHeight={{ base: '35px', sm: '49px' }}
                  m={{ base: '0 0 0 5px', lg: '0 0 0 29px' }}
                >
                  {PackageData[0]?.package_amount}{' '}
                  <Text as="span" fontSize={{ base: '15px', sm: '32px' }}>
                    {PackageData[0]?.currency}{' '}
                  </Text>
                  <Text as="span" fontSize="16px" color="#ffffff">
                    {subscripData?.sectionContent[13]?.text}
                  </Text>
                </Box>
                <UnorderedList
                  display="inline-block"
                  fontSize={{ base: '12px', lg: '12px' }}
                  fontFamily="FedraSansStd-book"
                  listStyleType="none"
                  textAlign="center"
                  width="100%"
                  color="#ffffff"
                >
                  <ListItem p="15px 0" borderTop="1px solid #ffffff">
                    {subscripData?.sectionContent[1]?.text}
                  </ListItem>
                  <ListItem p="15px 0" borderTop="1px solid #ffffff">
                    {subscripData?.sectionContent[2]?.text}
                  </ListItem>
                  <ListItem p="15px 0" borderTop="1px solid #ffffff">
                    {subscripData?.sectionContent[3]?.text}
                  </ListItem>
                </UnorderedList>
                <Box>
                  {subscripData?.sectionContent[7]?.buttonText != '' &&
                    subscripData?.sectionContent[7]?.linkUrl != '' && (
                      <Button
                        background="#ffbd31"
                        _hover={{ background: '#ffbd31' }}
                        _active={{ background: '#ffbd31' }}
                        _focus={{ boxShadow: 'none' }}
                        w={{ base: '100%', sm: '100%', lg: '100%' }}
                        m="14px auto 0"
                        height="50px"
                        fontWeight="normal"
                        cursor="pointer"
                        onClick={() =>
                          formsubmit(
                            `${PackageData[0]?.package_name}`,
                            `${PackageData[0]?.iso2}`
                          )
                        }
                      >
                        <Link
                          w="100%"
                          m="2px auto 0"
                          fontFamily="FedraSansStd-A-medium"
                          fontSize={{ base: '16px', lg: '16px' }}
                          lineHeight="48px"
                          textAlign="center"
                          display="block"
                          background="#ffbd31"
                          color="#2c2a29"
                          borderRadius="7px"
                          _hover={{ textDecor: 'none' }}
                        >
                          {subscripData?.sectionContent[7]?.buttonText}
                        </Link>
                      </Button>
                    )}
                </Box>
              </Box>
              <Box
                background="#2f2c29"
                marginTop="30px"
                borderRadius="12px"
                padding={{
                  base: '30px 25px 20px 25px',
                  lg: '30px 25px 20px 25px',
                }}
                width={{ base: '100%', sm: '96%', lg: '44%' }}
                margin="30px auto 0"
              >
                <Box
                  fontSize="28px"
                  fontFamily="FedraSansStd-A-medium, sans-serif"
                  color="#ffffff"
                >
                  {subscripData?.sectionContent[6]?.text}
                </Box>
                <Text
                  color="#ffbd31"
                  background="#2f2c29"
                  padding="5px"
                  fontFamily="FedraSansStd-medium"
                  fontSize={{ base: '10px', sm: '12px' }}
                  margin="0 auto"
                  w="max-content"
                  height="28px"
                ></Text>
                <Box
                  fontSize={{ base: '32px', sm: '48px' }}
                  color="#ffbd31"
                  fontFamily="FedraSansStd-book, sans-serif"
                  lineHeight={{ base: '35px', sm: '49px' }}
                  m={{ base: '0 0 0 5px', lg: '0 0 0 29px' }}
                >
                  {PackageData[1]?.package_amount}{' '}
                  <Text as="span" fontSize={{ base: '15px', sm: '32px' }}>
                    {PackageData[1]?.currency}{' '}
                  </Text>
                  <Text as="span" fontSize="16px" color="#ffffff">
                    {subscripData?.sectionContent[14]?.text}
                  </Text>
                </Box>
                <UnorderedList
                  display="inline-block"
                  fontSize={{ base: '12px', lg: '12px' }}
                  fontFamily="FedraSansStd-book"
                  listStyleType="none"
                  textAlign="center"
                  width="100%"
                  height="150px"
                  color="#ffffff"
                >
                  <ListItem p="15px 0" borderTop="1px solid #ffffff">
                    {subscripData?.sectionContent[1]?.text}
                  </ListItem>
                  <ListItem p="15px 0" borderTop="1px solid #ffffff">
                    {subscripData?.sectionContent[3]?.text}
                  </ListItem>
                </UnorderedList>
                <Box>
                  {subscripData?.sectionContent[7]?.buttonText != '' &&
                    subscripData?.sectionContent[7]?.linkUrl != '' && (
                      <Button
                        background="#ffbd31"
                        _hover={{ background: '#ffbd31' }}
                        _active={{ background: '#ffbd31' }}
                        _focus={{ boxShadow: 'none' }}
                        w={{ base: '100%', sm: '100%', lg: '100%' }}
                        m="14px auto 0"
                        height="50px"
                        fontWeight="normal"
                        cursor="pointer"
                        onClick={() =>
                          formsubmit(
                            `${PackageData[1]?.package_name}`,
                            `${PackageData[1]?.iso2}`
                          )
                        }
                      >
                        <Link
                          w="100%"
                          fontFamily="FedraSansStd-A-medium"
                          fontSize={{ base: '16px', lg: '16px' }}
                          lineHeight="48px"
                          textAlign="center"
                          display="block"
                          background="#ffbd31"
                          color="#2c2a29"
                          borderRadius="7px"
                          _hover={{ textDecor: 'none' }}
                        >
                          {subscripData?.sectionContent[7]?.buttonText}
                        </Link>
                      </Button>
                    )}
                </Box>
              </Box>
            </Box>
            <Box m="5px 0 0 0">
              <Text
                fontSize="16px"
                fontFamily="FedraSansStd-book"
                // borderBottom="1px solid #ffbd31"
                color="#ffbd31"
                className="privacylink"
              >
                {StructuredTextContent(subscripData?.sectionContent[8]?.body)}
              </Text>
            </Box>
          </>
        )}
      </form>

      <style global jsx>{`
        .selectplan input[type='radio'] {
          width: 42px;
          height: 42px;
        }
        .selectplan input[type='radio']:after {
          width: 42px;
          height: 42px;
          top: 0px;
          left: 0px;
          position: relative;
          content: '';
          background-color: #000000;
          border-radius: 50%;
          display: inline-block;
          visibility: visible;
        }
        .selectplan input[type='radio']:checked:after {
          width: 42px;
          height: 42px;
          border-radius: 0px;
          top: 0px;
          left: 0px;
          position: relative;
          content: '';
          border-radius: 50%;
          background-image: url(/assets/images/mark.svg);
          display: inline-block;
          visibility: visible;
        }
        @media screen and (max-width: 768px) {
          .selectplan input[type='radio'] {
            width: 24px;
            height: 24px;
          }
          .selectplan input[type='radio']:after {
            width: 24px;
            height: 24px;
            background-size: 24px;
          }
          .selectplan input[type='radio']:checked:after {
            width: 24px;
            height: 24px;
            background-size: 24px;
          }
        }
      `}</style>
    </>
  );
};

export default SubscriptionPlan;
